import {
	formatErrors,
	getFormValues,
	logger,
	userParams,
	validateAuthEmployeeForm,
	validateAuthForm
} from 'helpers';
import { useAMLStatus } from 'hooks/useAMLStatus';
import { AppContext } from 'providers/AppContext';
import { type FormEventHandler, useContext, useState } from 'react';
import { handleUserForm } from './AuthenticateHelpers';

const SHOW_COSTS_FOR_FLOW_TYPES: { [key: string]: boolean } = { eb: true, er: true, mv: true };

export function useAuthenticate() {
	useAMLStatus();

	const ctx = useContext(AppContext);
	const { config, t } = ctx;
	const { IS_EMPLOYEE_WEB } = config;
	const { companyKennitala } = userParams();
	const [isManualSignCompany, setIsManualSignCompany] = useState(!!companyKennitala);
	const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});

	const onSubmit: FormEventHandler<HTMLFormElement> = e => {
		e.preventDefault();
		e.stopPropagation();
		const formValues = getFormValues(e.currentTarget);
		const errors = (IS_EMPLOYEE_WEB ? validateAuthEmployeeForm : validateAuthForm)(formValues);
		if (Object.keys(errors).length) {
			setFormErrors(formatErrors(errors, t));
			logger('ERROR_MESSAGE', formValues, errors);
		} else {
			setFormErrors({});
			handleUserForm(ctx, formValues);
		}
	};

	return {
		...ctx,
		formErrors,
		isManualSignCompany,
		onSubmit,
		setIsManualSignCompany,
		SHOW_COSTS_FOR_FLOW_TYPES
	};
}
